<app-modal [modalConfig]="modalConfig">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <div class="create-user">
            <div class="input-container">
                <label>
                    Nombres
                    <span class="mandatory">*</span>
                </label>
                <input class="form-input" formControlName="nombre" type="text" autocomplete="off" [ngClass]="{ error: hasErrors('nombre') }" />
            </div>
            <div class="input-container">
                <label>
                    Apellidos
                    <span class="mandatory">*</span>
                </label>
                <input class="form-input" formControlName="apellido" type="text" autocomplete="off" [ngClass]="{ error: hasErrors('apellido') }" />
            </div>
            <div class="input-container">
                <label>
                    Correo Electrónico
                    <span class="mandatory">*</span>
                </label>
                <input class="form-input" formControlName="email" type="email" autocomplete="off" [ngClass]="{ error: hasErrors('email') }" />
            </div>
            <div class="input-container">
                <label>
                    Rol
                    <span class="mandatory">*</span>
                </label>
                <select class="form-input" formControlName="rol" [ngClass]="{ error: hasErrors('rol') }">
                    <option [ngValue]="null" selected disabled hidden>Seleccione</option>
                    <option *ngFor="let option of roles | keyvalue" [value]="option.key">{{ option.value }}</option>
                </select>
            </div>

            <div class="input-container" *ngIf="userModules.length > 0">
                <label> Permisos </label>
                <div [ngClass]="{ error: hasErrors('permissions') }" class="flex-container">
                    <label class="flex-item" *ngFor="let option of userModules">
                        <input #permissionCheck type="checkbox" [(ngModel)]="option.isSelected" [ngModelOptions]="{ standalone: true }" />
                        {{ option.name }}
                    </label>
                </div>
            </div>
            <button class="btn-submit" [disabled]="isLoading">{{ actionButton }}</button>
        </div>
        <ngx-ui-loader loaderId="manage-user" [hasProgressBar]="false"></ngx-ui-loader>
    </form>
</app-modal>
